import { TabPageDefinition } from '@/components/tab-pages';

type AvailableTabs =
  | 'Today sessions'
  | 'Future sessions'
  | 'Student feedbacks'
  | 'Past sessions'
  | 'Sub sessions'
  | 'Overlapping sessions';

export const sessionsTabs = (selectedTab?: AvailableTabs): TabPageDefinition[] => {
  return [
    {
      label: "Today's sessions",
      linkProps: {
        to: '/sessions',
      },
      isSelectedTab: selectedTab === 'Today sessions' || !selectedTab, // Default to 'Today sessions' if no tab is selected
    },
    {
      label: 'Future sessions',
      linkProps: {
        to: '/sessions/future',
      },
      isSelectedTab: selectedTab === 'Future sessions',
    },
    {
      label: 'Past sessions',
      linkProps: {
        to: '/sessions/past',
      },
      isSelectedTab: selectedTab === 'Past sessions',
    },
    {
      label: 'Sub sessions',
      linkProps: {
        to: '/sessions/sub-sessions',
      },
      isSelectedTab: selectedTab === 'Sub sessions',
    },
    {
      label: 'Overlapping sessions',
      linkProps: {
        to: '/sessions/overlapping',
      },
      isSelectedTab: selectedTab === 'Overlapping sessions',
    },
    {
      label: 'Student feedback',
      linkProps: {
        to: '/sessions/session-feedbacks',
      },
      isSelectedTab: selectedTab === 'Student feedbacks',
    },
  ];
};
